import {
    API_COMMON_URL,
    AUTH,
    FAILURE,
    LOGOUT,
    REGISTER,
    SET,
    SUCCESS_STATUS,
    USER_INFO,
} from '../constants/constants';
import { getTariffs, saveKey, eraseKey } from './pagesActions';
import { getLogger } from '../../lib/devMode';
import { setDomains, setDomainsFromQuery } from './cartAction';
import { redirectToPayment } from './checkout';

export const authenticate = (data) => (dispatch) => {
    dispatch({
        type: AUTH,
        postData: data,
        CallAPI: API_COMMON_URL + '?method_name=user_authorize',
    }).then((data) => {
        if (
            data?.apiData?.data?.operation_status === SUCCESS_STATUS
            && data?.apiData?.data?.payment_page_token
        ) {
            dispatch(saveKey(undefined, data.apiData.data.payment_page_token)).then(() => {
                // Unset domains since they are specific to each user.
                dispatch(setDomains({ domains: [] }));
            }).then(() => {
                // Fetch individual tariffs.
                dispatch(getTariffs());
            });
        }
    }).catch((error) => {
        getLogger().error(error);
        dispatch({
            type: AUTH + FAILURE,
        });
    });
};

export const register = (data) => (dispatch) => {
    dispatch({
        type: REGISTER,
        postData: data,
        CallAPI: API_COMMON_URL + '?method_name=get_api_key',
    }).then((response) => {
        if (!!response?.apiData?.data?.payment_page_token) {
            dispatch(saveKey(undefined, response.apiData.data.payment_page_token)).then(() => {
                // Unset domains since they are specific to each user.
                dispatch(setDomains({ domains: [] }));
            }).then(() => {
                // Fetch individual tariffs.
                dispatch(getTariffs());
            }).then(() => {
                if (data.proceedToCheckoutAfterAuth) {
                    dispatch(redirectToPayment(data.proceedToCheckoutAfterAuth));
                }
            });
        }
    }).catch((error) => {
        getLogger().error(error);
        dispatch({
            type: REGISTER + FAILURE,
        })
    });
};

export const logout = () => (dispatch) => {
    return dispatch({
        type: LOGOUT,
    }).then(() => {
        dispatch(eraseKey()).then(
            () => dispatch({ type: USER_INFO + SET, data: {} }).then(() => {
                // Unset domains since they are specific to each user.
                dispatch(setDomainsFromQuery({ domains: [] }));
            }).then(() => {
                // Fetch tariffs for non-registered user.
                dispatch(getTariffs());
            })
        );
    }).catch((error) => {
        getLogger().error(error);
    });
};
